import React from "react";
import WorkorderService from "../services/workorders";
import UserService from "../services/users";
import WorkorderList from "../components/workorders/workorderlist";
import ActionButton from '../components/layout/actionButtons';
import Search from "../components/general/search";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Holidays from "../components/users/holiday";
import Baby from "../components/users/baby";
import Docters from "../components/users/docter";
import WorkorderItemService from '../services/workorderitems';
import CalendarService from '../services/calendar';
import moment from 'moment';
import CalendarView from "../components/calendar/view";
class Workorders extends React.Component {
  constructor(props) {
    super(props);
    this.state = { items: [], filterItems: [], selectedStatus: 0, calenderItems: [] };
  }

  componentDidMount() {
    UserService.validSecuritySession()
      .then(
        (result) => {

        }, (error) => {
          this.props.history.push('/login');
        })
    this.props.handleMenu(
      {
        title: 'Mijn werkbonnen',
        handleActions: <ActionButton {...this.props} handleNew={this.newItem}></ActionButton>
      })
    this.getItems();
    this.getFreeTime();
  }

  compare(a, b) {
    if (a.created < b.created)
      return 1;
    if (a.created > b.created)
      return -1;
    return 0;
  }

  getItems() {
    WorkorderService.get().then(
      result => {
        result = result.sort(this.compare)
        this.setState({ items: result, filterItems: result });
      },
      error => {
        console.log("error", error);
      }
    );
    CalendarService.get().then(
      (result) => {
        this.setState({ calenderItems: result.filter(item => { return moment(item.start).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') }) });
      },
      (err) => {

      }
    )
  }

  newItem = () => {
    if (this.state.items.filter((item) => { return item.status === 0 }).length > 0) {
      window.confirm("Er staat nog een werkbon in concept, weet u zeker dat u een nieuwe werkbon wilt aanmaken?") &&
        WorkorderService.createNewOrder(UserService.currentUser()._id)
          .then(newItem => {
            this.props.history.push('/workorders/' + newItem.guid);
          })
          .catch(ex => {
            this.props.handleMessage({ title: "Kan op dit moment geen nieuwe werkbon aanmaken" });
          })
    } else {
      WorkorderService.createNewOrder(UserService.currentUser()._id)
        .then(newItem => {
          this.props.history.push('/workorders/' + newItem.guid);
        })
        .catch(ex => {
          this.props.handleMessage({ title: "Kan op dit moment geen nieuwe werkbon aanmaken" });
        })
    }
  }

  editItem = (item) => {
    this.props.history.push('/workorders/' + item.guid);
  }
  handleChangeStatusTab = (event, value) => {
    this.setState({ selectedStatus: value })
  }


  handleSearch = (search) => {
    let filterItems = this.state.items;
    filterItems = filterItems.filter((item) => { return (JSON.stringify(item).toLowerCase().indexOf(search.toLowerCase()) >= 0) });
    this.setState({ filterItems })
  }

  getFreeTime = () => {
    let user = UserService.currentUser();
    if (user) {
      WorkorderItemService.getHolidayForUser(user._id).then(
        result => {
          //  console.log("holiday", result);
          this.setState({ holidays: result });
        },
        error => {
          console.log("error", error);
        }
      );

      WorkorderItemService.getDoctersForUser(user._id).then(
        result => {
          //  console.log("holiday", result);
          this.setState({ docters: result });
        },
        error => {
          console.log("error", error);
        }
      );

      WorkorderItemService.getBabiesForUser(user._id).then(
        result => {
          //  console.log("holiday", result);
          this.setState({ babies: result });
        },
        error => {
          console.log("error", error);
        }
      );
    }

  }

  render() {
    const { selectedStatus } = this.state;
    const items = this.state.filterItems.filter((item) => { if (item.status === 0 && selectedStatus === 0) { return true }; if ((item.status === 1 || item.status === 2) && selectedStatus === 1) { return true }; if ((item.status === 3) && selectedStatus === 2) { return true }; return false })
    const countConcept = this.state.filterItems.filter((item) => { if (item.status === 0) { return true } else { return false } }).length;
    const countOpen = this.state.filterItems.filter((item) => { if (item.status === 1 || item.status === 2) { return true } else { return false } }).length;
    const countArchive = this.state.filterItems.filter((item) => { if (item.status === 3) { return true } else { return false } }).length;

    return (
      <React.Fragment>
        <AppBar position="static" color="secondary">
          <Tabs value={selectedStatus} onChange={this.handleChangeStatusTab}>
            <Tab label={'Concept (' + countConcept + ')'} />
            <Tab label={'Openstaand (' + countOpen + ')'} />
            <Tab label={'Archief (' + countArchive + ')'} />
            <Tab label={'Verlof uren'} />
          </Tabs>
        </AppBar>

        <div>
          {selectedStatus === 3 ?
            < div className="padding">
              <h3> Vakantie uren</h3>
              <Holidays user={UserService.currentUser()._id} holidays={this.state.holidays || []} readonly={true} />
              <h3> Dokter</h3>
              <Docters user={UserService.currentUser()._id} docters={this.state.docters || []} readonly={true} />
              <h3> Ouderschapsverlof</h3>
              <Baby user={UserService.currentUser()._id} babies={this.state.babies || []} readonly={true} />
            </div>
            : <>
              <Search handleSearch={this.handleSearch} />
              <CalendarView items={this.state.calenderItems} readOnly={true} history={this.props.history} />
              <WorkorderList items={items} handleEdit={this.editItem} showUserInfo={false} />
            </>
          }

        </div>
      </React.Fragment>
    );
  }
}
export default Workorders;
